import { useTranslation } from "@opendash/i18n";

import { Col, DatePicker, Divider, Row, Segmented } from "antd";
import dayjs, { Dayjs } from "dayjs";

import * as React from "react";

interface Props {
  value?: [number, number];
  onChange?: (value: [number, number], mode: selectionModeType) => void;
  mode?: selectionModeType;
  style?: React.CSSProperties;
}
type selectionModeType =
  | "none"
  | "custom"
  | "day"
  | "week"
  | "month"
  | "quarter"
  | "year";
export const FixedIntervalPicker = ({
  value = [new Date().getTime(), new Date().getTime()],
  onChange = (dates, mode) => {},
  mode = "day" as selectionModeType,
  style = {},
}: Props) => {
  const t = useTranslation();
  const [selectionMode, setSelectionMode] =
    React.useState<selectionModeType>(mode);
  const [dates, setDates] = React.useState<[Dayjs, Dayjs]>([
    dayjs(value[0]),
    dayjs(value[1]),
  ]);

  React.useEffect(() => {
    if (mode === "none") {
      setDates([null, null]);
    }
  }, [mode]);
  React.useEffect(() => {
    onChange(
      [dates[0].toDate().getTime(), dates[1].toDate().getTime()],
      selectionMode
    );
  }, [dates]);
  React.useEffect(() => {
    if (selectionMode === "none") {
      setDates([null, null]);
    }
    if (selectionMode === "day") {
      setDates([dayjs().startOf("day"), dayjs().endOf("day")]);
    }
    if (selectionMode === "week") {
      setDates([dayjs().startOf("week"), dayjs().endOf("week")]);
    }
    if (selectionMode === "month") {
      setDates([dayjs().startOf("month"), dayjs().endOf("month")]);
    }
    if (selectionMode === "quarter") {
      const startMonth = dayjs().set(
        "month",
        dayjs().get("month") - ((dayjs().get("month") + 1) % 3)
      );
      setDates([
        startMonth.startOf("month"),
        startMonth.add(3, "month").endOf("month"),
      ]);
    }
    if (selectionMode === "year") {
      setDates([dayjs().startOf("year"), dayjs().endOf("year")]);
    }
  }, [selectionMode]);
  return (
    <div style={{ backgroundColor: "#FFF", padding: 16, ...style }}>
      {/* <p>{t("opendash:dashboards.timerange_modal_description")}</p> */}
      <Row gutter={16}>
        <Col span={24}>
          <Segmented
            block
            style={{ width: "100%" }}
            value={selectionMode}
            onChange={(selection) => {
              setSelectionMode(selection as selectionModeType);
            }}
            options={[
              { label: t("opendash:ui.discard"), value: "none" },
              {
                label: t(
                  "opendash:monitoring.explorer.step_fetching_time_absolute"
                ),
                value: "custom",
              },
              { label: t("opendash:ui.day"), value: "day" },
              { label: t("opendash:ui.week"), value: "week" },
              { label: t("opendash:ui.month"), value: "month" },
              { label: t("opendash:ui.quarter"), value: "quarter" },
              { label: t("opendash:ui.year"), value: "year" },
            ]}
          />
        </Col>
      </Row>
      {selectionMode !== "none" && <Divider />}
      {selectionMode !== "none" && (
        <Row>
          <Col span={24}>
            {selectionMode === "custom" && (
              <DatePicker.RangePicker
                showTime
                value={dates}
                style={{ width: "100%" }}
                onChange={(date) => {
                  setDates(date);
                }}
              />
            )}
            {selectionMode !== "custom" && (
              <DatePicker
                value={dates[0]}
                onChange={(date) => {
                  let dateunit = selectionMode;
                  if (dateunit == "quarter") dateunit = "month";

                  let end = date.endOf(
                    selectionMode as "week" | "year" | "month"
                  );
                  if (selectionMode === "quarter") {
                    end = end.add(2, "month");
                  }
                  setDates([
                    date.startOf(selectionMode as "week" | "year" | "month"),
                    end,
                  ]);
                }}
                style={{ width: "100%" }}
                picker={selectionMode as "week" | "quarter" | "year" | "month"}
              />
            )}
          </Col>
        </Row>
      )}
    </div>
  );
};
